<template>
  <div class="pull-height animated" :class="{'zoomOutUp': isLock}">
    <navbar />
    <div class="body">
      <sidebar />
      <div class="main-container">
        <div class="main" ref="ciicMainBox">
          <div class="router" id="main" ref="ciicMain">
            <keep-alive>
              <router-view @toTop="scrolltop" v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
            </keep-alive>
            <router-view @toTop="scrolltop" v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import navbar from './navbar/';
import sidebar from './sidebar/';
import store from '@/store';

export default {
  components: {
    navbar,
    sidebar,
  },
  name: 'index',
  data() {
    return {
      isRouterAlive: true,
      dicts: {}
    };
  },
  created() {
    this.getDicts().then((res) => {
      this.dicts = res.data.data;
      this.$store.commit('SET_DICTS', this.dicts)
      console.log("🚀 ~ file: index.vue ~ line 79 ~ this.getDicts ~ this.dicts", this.dicts)
    });
  },
  mounted() {
    document.documentElement.style = '';
    // 主题 light-theme/白  dark-theme/黑
    if (typeof (localStorage.Theme) == "undefined") {
      localStorage.setItem('Theme', "light-theme");
      localStorage.setItem('Color', "#000000");
    }
    document.getElementsByTagName("body")[0].className = localStorage.getItem("Theme");
    this.$store.commit('SET_WORKSPACE_RECT', this.$refs.ciicMain);

  },
  computed: {
    ...mapGetters(['isLock', 'menu'])
  },
  props: [],
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 回到顶部
    scrolltop() {
      this.$refs.ciicMainBox.scrollTop = 0
    }
  },
};
</script>

<style lang="scss" scoped>
.body {
  display: flex;
  position: relative;
  background: #fff;
  overflow: hidden;
  height: 100%;

  .main-container {
    position: relative;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    flex: 1;
    min-width: calc(100vw - 245px);
    max-width: calc(100vw - 58px);
    background: #F6F7F9;
  }

  .main {
    width: 100%;
    height: calc(100vh - 48px);
    background: #F6F7F9;
    box-sizing: border-box;
    overflow: hidden;

    .router {
      width: 100%;
      padding: 24px;
      background: #F6F7F9;
      //min-height: 100%;
      height: 100%;
      overflow-y: auto;
      //overflow: hidden;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
}

</style>
